import React from 'react';
import Wrapper from "./Wrapper";
import logo from '../../assets/Images/logo.svg';
import {Link} from 'react-router-dom';
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faGithub, faInstagram, faLinkedin, faTelegram} from "@fortawesome/free-brands-svg-icons";

const Footer = ({className}) => {
    return (
        <footer className={`${className} relative py-2 border-t-2 text-black`}>
            <Wrapper>
                <div className='flex flex-1 flex-wrap lg:flex-nowrap gap-y-12 xl:gap-y-0 gap-x-16 my-2 lg:my-10 justify-between'>
                    <div className='w-full lg:w-2/6 flex flex-col'>
                        <Link
                            to="/"
                            className="relative flex items-center mb-6">
                            <img src={logo} alt="Logo" className="h-14 rounded-sm" />
                            <span className="text-2xl font-bold text-light-primary">کدپرو</span>
                        </Link>
                        <p className='text-lg leading-8 text-gray-700'>هدف از ساختن پلتفرم کدپرو این است که آموزش و یادگیری برنامه‌نویسی سریع‌تر و آسان‌تر شود و تجربه‌ای عالی برای کاربران باشد.</p>
                        <h3 className='text-xl font-bold mt-12 mb-6'>شبکه‌اجتماعی</h3>
                        <div className='flex items-center gap-x-5 w-full'>
                            <Link to='https://instagram.com/codepro.ir' className='hover:opacity-70 hover:-translate-y-2'><FontAwesomeIcon icon={faInstagram} size='2xl' /></Link>
                            <Link to='https://telegram.me/codepro_ir' className='hover:opacity-70 hover:-translate-y-2'><FontAwesomeIcon icon={faTelegram} size='2xl' /></Link>
                        </div>
                    </div>
                    <div className='w-1/2 xl:w-1/6'>
                        <span className='text-2xl font-bold mb-5 block'>کدپرو</span>
                        <ul className='flex flex-col gap-y-1 text-lg list-none'>
                            <li><Link to='https://www.goftino.com/c/2FqaT1' className='hover:opacity-70'>پشتیبانی</Link></li>
                            <li><Link to='/rules/' className='hover:opacity-70'>قوانین و مقررات</Link></li>
                            <li><Link to='https://survey.porsline.ir/s/ygReOZvK' className='hover:opacity-70'>نظرسنجی</Link></li>
                        </ul>
                    </div>
                    <div className='w-1/2 xl:w-1/6'>
                        <span className='text-2xl font-bold mb-5 block'>لینک‌های مفید</span>
                        <ul className='flex flex-col gap-y-1 text-lg list-none'>
                            <li><Link to='/blog/' className='hover:opacity-70'>بلاگ</Link></li>
                        </ul>
                    </div>
                    <div className='w-1/2 xl:w-1/6'></div>
                </div>
                <div className='relative w-full justify-center mt-8 md:text-2xl text-lg lg:text-md flex'>
                    تمامی حقوق
                    <span className='flex items-center ml-2 mr-2 text-light-primary'>
                        <span>کدپرو</span>
                        <img src={logo} alt='logo' className='h-6 block mr-2 rounded-sm'/>
                    </span> محفوظ
                    می
                    باشد &copy;
                </div>
            </Wrapper>
        </footer>
    );
};

export default Footer;